import styled from "styled-components";

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr 1fr;
  padding-left: 2rem;
  padding-right: 2rem;
  .button--container {
    grid-column-start: 2;
    grid-row-start: 4;
    margin-top: 3.2rem;
  }
  .model {
    margin-top: 3.2rem;
  }
  .clickable-element {
    cursor: pointer;
  }
`;

export const optionGray = styled.option`
  ${({ theme }) => `
    color: ${theme.colors.blackTextTitle};
  `}
`;

export const Subtitle = styled.h2`
  ${({ theme }) => `
    color: ${theme.colors.blackTextTitle};
  `}
  font-size: 1.4rem;
  font-weight: 600;
`;

interface IMainButton {
  isLoading?: any;
  isDisabled?: any;
}
export const MainButton = styled.button<IMainButton>`
  ${(props) => `
    cursor: ${props.isLoading ? "default" : "pointer"};
    font-family: ${props.theme.fontFamilies.primaryFont};
    background-color: ${
      props.isDisabled
        ? props.theme.colors.accentGreen + props.theme.transparencies.p20
        : props.theme.colors.accentGreen
    };
  `}
  align-items: center;
  border-radius: 8px;
  border: none;
  color: ${(props) => props.theme.colors.white};
  display: flex;
  font-size: 1.7rem;
  font-weight: 700;
  height: 6.4rem;
  justify-content: center;
  width: 34.8rem;

  img {
    height: 5rem;
    width: 5rem;
  }
`;
